<template>
  <section class="invoice-detail-summary-section">
    <freelancer-invoice-detail-hour-row v-for="(row,i) in proforma.hour_rows" :key="i"
                                        :row="row" />
    <freelancer-invoice-detail-travel-costs v-if="proforma.total_travels > 0"
                                            :rate="proforma.travel_rate"
                                            :distance="proforma.total_travels" />
  </section>
</template>
<script lang="ts" setup>

import { Proforma } from '../types';
import FreelancerInvoiceDetailHourRow from './FreelancerInvoiceDetailHourRow.vue';
import FreelancerInvoiceDetailTravelCosts from './FreelancerInvoiceDetailTravelCosts.vue';

defineProps<{
  proforma: Proforma,
}>();

</script>
